import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { IVariantGridData } from '@app/add-product/models/variant-grid-data-model';
import { VariantGridDataService } from '@app/@core/services/variant-grid-data/variant-grid-data.service';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { EditQuantityDialogComponent } from '@app/@shared/modals/edit-quantity-dialog/edit-quantity-dialog.component';
import * as _ from 'lodash';

@Component({
    selector: 'sp-variant-grid-table',
    templateUrl: './variant-grid-table.component.html',
    styleUrls: ['./variant-grid-table.component.scss'],
})
export class VariantGridTableComponent implements OnInit {
    // totalRecords: number = 0;
    matTableDataSource: MatTableDataSource<any>;
    // paginator: any;
    displayedColumns1: string[] = ['select', 'variant', 'quantity', 'actions'];
    selection: SelectionModel<IVariantGridData> =
        new SelectionModel<IVariantGridData>(true, []);
    variantsQuantity: number = 1;
    variantGriddata: Array<IVariantGridData> = [];
    variantGridDataServiceSubscription: Subscription;
    @Output() variantsDeletedEvent = new EventEmitter<boolean>();
    @Output() variantsUpdatedEvent = new EventEmitter<boolean>();

    constructor(
        private variantGridDataService: VariantGridDataService,
        private dialog: MatDialog
    ) {}

    ngOnInit(): void {
        this.variantGridDataServiceSubscription = this.variantGridDataService
            .getUpdatedVariantGridDataObservable()
            .subscribe((variantGriddata: Array<IVariantGridData>) => {
                this.variantGriddata = variantGriddata;
                if (this.variantGriddata.length === 0) {
                    this.displayedColumns1 = this.displayedColumns1.filter(
                        (column) => column !== 'actions'
                    );
                    this.matTableDataSource = new MatTableDataSource([
                        { variant: '--', quantity: '--' },
                    ]);
                } else {
                    if (!this.displayedColumns1.includes('actions')) {
                        this.displayedColumns1.push('actions');
                    }
                    this.matTableDataSource = new MatTableDataSource(
                        this.variantGriddata
                    );
                }
            });
    }

    isAllSelected(): boolean {
        const numSelected = this.selection.selected.length;
        const numRows = this.matTableDataSource.data.length;
        return numSelected === numRows;
    }

    masterToggle() {
        this.isAllSelected()
            ? this.selection.clear()
            : this.matTableDataSource.data.forEach((row: IVariantGridData) =>
                  this.selection.select(row)
              );
    }

    checkboxLabel(row?: any): string {
        if (!row) {
            return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
        }
        return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${
            row.position + 1
        }`;
    }

    deleteSingleVariant(index: number): void {
        const selectedItems: Array<IVariantGridData> =
            this.variantGriddata.splice(index, 1);
        this.variantGridDataService.deleteVariants(
            this.variantGriddata,
            selectedItems
        );
        this.variantsDeletedEvent.emit(true);
    }

    deleteVariants(): void {
        let selectedItems: Array<IVariantGridData> = [];

        this.selection.selected.forEach((item) => {
            const index = this.variantGriddata.indexOf(item);
            if (index > -1) {
                selectedItems.push(...this.variantGriddata.splice(index, 1));
            }
        });
        this.selection.clear();
        this.variantGridDataService.deleteVariants(
            this.variantGriddata,
            selectedItems
        );
        this.variantsDeletedEvent.emit(true);
    }

    openEditQuantityDialog(): void {
        const dialogRef = this.dialog.open(EditQuantityDialogComponent, {
            width: '450px',
            height: '108px',
            data: { count: this.selection.selected.length },
            position: { right: '300px', top: '430px' },
        });

        dialogRef.afterClosed().subscribe((data) => {
            if (data.clickedOnButton) {
                this.updateQuantityToVariants(data.qty);
            }
        });
    }

    updateQuantityToRow(quantity: number, i: number) {
        let variantGriddata: Array<IVariantGridData> = _.cloneDeep(
            this.variantGriddata
        );
        variantGriddata[i].quantity = +quantity;
        this.variantGridDataService.updateQuantityToVariants(
            variantGriddata,
            1
        );
    }

    updateQuantityToVariants(variantsQuantity: number): void {
        let variantGriddata: Array<IVariantGridData> = _.cloneDeep(
            this.variantGriddata
        );
        this.selection.selected.forEach((item) => {
            const index = this.variantGriddata.indexOf(item);
            if (index > -1) {
                variantGriddata[index].quantity = +variantsQuantity;
            }
        });
        this.variantGridDataService.updateQuantityToVariants(
            variantGriddata,
            this.selection.selected.length
        );
        this.selection.clear();
        this.variantsUpdatedEvent.emit(true);
    }

    ngOnDestroy(): void {
        this.variantGridDataServiceSubscription.unsubscribe();
    }

    isColorAndSizeLabelsAvailable(): boolean {
        return (
            this.variantGriddata.length > 0 &&
            this.variantGriddata.some((row) => row.colorLabel && row.sizeLabel)
        );
    }
}
